<template>
  <div v-if="!isBranded()" class="mt-3 mb-2 container d-flex justify-content-center align-items-center">
    <span :style="showNewUi && 'font-size: 12.8px'" class="poweredby-text">{{ $t('message.poweredBy') }}</span>
    <a
      href="https://abacus.co"
      alt="The iPad POS System you love"
      title="The iPad POS System you love"
      target="_blank"
      rel="noopener noreferrer"
    >
      <!--add rel=noopener noreferrer to this link to prevent the original page from being modified by the opened link-->
      <img :class="showNewUi ? 'poweredby-new-image' : 'poweredby-image'" :src="logoUrl" alt="logo" />
    </a>
  </div>
</template>
<script>
import { wcconfig } from "../../../wcConfig";
import {mapGetters} from "vuex";
export default {
  data() {
    return {
      logoUrl: ""
    };
  },
  created() {
    this.logoUrl = wcconfig.assets.abacus;
  },
  computed: {
    ...mapGetters([
      "showNewUi",
    ]),
  },
};
</script>
